// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"8eeb1f8dc3bb740c863f","293":"5430ed17988aae2f48b7","522":"1b14ab3a172eb85d47c9"}[chunkId] + ".js";
};